<script>
  import { euroCouponsIssueMethods } from '@state/helpers'
  
  export default {
    name: 'DetailPayless',
    components: {},
    props: {
      instanceJson: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      oncomplete: {
        type: Function,
        required: false,
        default: () => ({}),
      },
      oncancel: {
        type: Function,
        required: false,
        default: () => ({}),
      },
    },
    data() {
      return {
        modalShow: true,
        loading: true,
        toDetail: {},
        reasonsOptions: [
          {label: 'Duplicada.', value: 1},
          {label: 'Mayor Valor.', value: 2},
          {label: 'Menor Valor.', value: 3},
          {label: 'No Coincide.', value: 4},
          {label: 'Redimida Correctamente.', value: 5}
        ],
      }
    },
    computed: {},
  
    mounted: function () {
      let context = this
      if (context.instanceJson.url) {
        context.toDetail = {
          ...context.instanceJson,
        }
        context.getObject()
      } else {
        context.oncancel()
      }
    },
  
    methods: {
      ...euroCouponsIssueMethods,
  
      getObject() {
        let context = this
        const promise = context.fetchEuroCouponsIssueDetail(context.toDetail.url)
        return promise
          .then((data) => {
            const option = this.reasonsOptions.find(option => option.value === data.reason);
              if (option) {
                data.reason_description=option.label;
              } else {
                data.reason_description= "Motivo no valido";
              }
            context.toDetail = { ...data }
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
            context.oncancel()
          })
      },
    },
  }
  </script>
  
  <template>
    <b-modal
      v-model="modalShow"
      :title="`${ $t('detail_of') } ${ $t('issue') }`"
      ok-only
      hide-footer
      @hidden="oncancel"
    >
      <b-container class="p-0">
        <b-row v-if="loading">
          <b-col md="12">
            <div class="text-center">
              <b-spinner
                label="Spinning"
                style="color: #195db2; width: 4rem; height: 4rem"
              ></b-spinner>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col  class="mx-auto" md="12">
            <b-card-group deck>
              <b-card>
                <b-alert show variant="primary" class="shadow-sm font-weight-bold">{{toDetail.reason_description}}</b-alert>
                <!-- <pre>
                  {{toDetail}}
                </pre> -->
  
              <b-list-group class="mb-3 border border-primary shadow">
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-file-invoice-dollar"></i> {{ $t('invoice') }}</b>
                  <b-badge variant="primary"  style="font-size: 13px">{{ toDetail.invoice }}</b-badge>
                </b-list-group-item>
                
                <b-list-group-item  class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-map-marker-alt"></i> {{ $t('operation_center') }}</b>
                  <b-badge variant="light"  style="font-size: 13px">{{ toDetail.CO }}</b-badge>
  
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-cash-register"></i> {{ $t('cash_register') }}</b>
                  <b-badge variant="light"  style="font-size: 13px">{{ toDetail.cash_register }}</b-badge>
                </b-list-group-item>
  
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-id-card-alt"></i> {{ $t('casher_register') }}</b>
                  <b-badge variant="light" style="font-size: 13px">{{ toDetail.cash_register_document }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-calendar-day"></i> {{ $t('date') }}</b>
                  <b-badge variant="light"  style="font-size: 13px">{{ toDetail.date }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-paperclip"></i> {{ $t('reason') }}</b>
                  <b-badge variant="light"  style="font-size: 13px">{{ toDetail.reason_description }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-sticky-note"></i> Nota Factura</b>
                  <b-badge variant="light"  style="font-size: 13px">{{ toDetail.nota }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-info"></i> Numero de Orden</b>
                  <b-badge variant="light"  style="font-size: 13px">{{ toDetail.order_id }}</b-badge>
                </b-list-group-item>
                <b-list-group-item
                class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-dollar-sign"></i> {{ $t('invoiced_amount') }}</b>
                  <b-badge variant="light" style="font-size: 13px">$ {{ $formatDollar(toDetail.amount) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item
                class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-qrcode"></i> {{ $t('barcode') }}</b>
                  <b-badge variant="light" style="font-size: 13px">{{ toDetail.code }}</b-badge>
                </b-list-group-item>
                <b-list-group-item
                class="d-flex justify-content-between align-items-center">
                  <b class="text-primary"><i class="fas fa-dollar-sign"></i> {{ $t('payless_amount') }}</b>
                  <b-badge variant="light" style="font-size: 13px">$ {{ $formatDollar(toDetail.amount_code) }}</b-badge>
                </b-list-group-item>
              </b-list-group>
  
  
              </b-card>
  
            </b-card-group>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </template>
  <style lang="scss">
  </style>